import FilterForm from './FilterForm';
import EmailResultsForm from './EmailResultsForm';
import PricingForm from './PricingForm';
import WarrantyRegForm from './WarrantyRegForm';
import WarrantyClaimsForm from './WarrantyClaimsForm';
import ManualsForm from './ManualsForm';

export {
  FilterForm,
  EmailResultsForm,
  PricingForm,
  WarrantyRegForm,
  WarrantyClaimsForm,
  ManualsForm
};



// WEBPACK FOOTER //
// ./src/forms/index.js